import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { LocaleProvider } from "./i18n/context.js";
import "./app.css";

const el = document.getElementById("root");
if (el) {
  createRoot(el).render(
    <LocaleProvider initial="en" locked="en">
      <App />
    </LocaleProvider>,
  );
}
